import React from "react";
import Slider from "react-slick";
import { Col, Row } from "react-bootstrap";

export default function Blog() {
    const cards = [
        {
            id: 1,
            date: "JULY 25, 2024",
            title: "Opportunities: Immigration Consulting",
            image: "images/dteam.webp",
        },
        {
            id: 2,
            date: "JULY 25, 2024",
            title: "10 Must-Visit Hidden Gems Your Next Vacation",
            image: "images/dteam1.webp",
        },
        {
            id: 3,
            date: "JULY 25, 2024",
            title: "How to Experience the World without Breaking",
            image: "images/dteam.webp",
        },
        {
            id: 4,
            date: "JULY 25, 2024",
            title: "Secrets to Planning an Affordable World Tour",
            image: "images/dteam1.webp",
        },
    ];

    // Slider settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay:true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992, // Adjust for medium screens
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768, // Adjust for small screens
                settings: {
                    slidesToShow: 1,
                    dots: true,
                },
            },
        ],
    };

    return (
        <div className="blog_bg">
            {/* <div className="blog-header text-center">
                <h6 className="blog-subtitle" style={{ color: "#b80505", letterSpacing: "1.5px" }}>
                    <i className="fa-regular fa-paper-plane" style={{ color: "#b80505", transform: "rotate(45deg)" }}></i>
                    &nbsp; NEWS & UPDATES <i className="fa-solid fa-earth-americas" style={{ color: "#b50808" }}></i>
                </h6>
                <h1 className="blog-title">Latest News & Articles From the Blog</h1>
            </div>
            <div className="blog-slider-container">
                <Slider {...settings}>
                    {cards.map((card) => (
                        <div key={card.id}>
                            <Row>
                                <Col className="mb-5">
                                    <div className="blog-card">
                                        <div className="blog-content-container">
                                            <div className="img-date-card">
                                                <div className="blog-date">{card.date}</div>
                                                <img
                                                    className="blog-image"
                                                    src={card.image}
                                                    alt={card.title}
                                                />
                                            </div>
                                            <div className="blog-card-content">
                                                <h3 className="blog-card-title">{card.title}</h3>
                                                <a href="#" className="blog-read-more">
                                                    READ MORE ➤
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    ))}
                </Slider>
            </div> */}
            <div className="footer-top">
                <div className="footer-top-support">
                    <h2>Your growth is our mission. Let’s shape your success story together! </h2>
                    {/* <div className="support">
                        <div className="support-head">
                            <i
                                className="fa-solid fa-headset fa-2xl headset-mic"
                                style={{ color: "white" }}
                            ></i>
                        </div>
                        <div className="support-headset">
                            <p>FEEL FREE TO CALL US</p>
                            <h3>+1 (647) 716-1330</h3>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
}
